import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { State } from "common/state/State";
import { Unsubscribe } from "./Unsubscribe";
import { Button, ButtonCategory } from "common/button/Button";

interface IEmailMarketingUnsubscribePageUIProps {
  loading: boolean;
  primaryEmail: string;
  emsUserToken: string;
  unsubscribeDomain: string;
}
export const EmailMarketingUnsubscribePageUI: React.FC<
  IEmailMarketingUnsubscribePageUIProps
> = ({ loading, primaryEmail, emsUserToken, unsubscribeDomain }) => {
  const [isUnsubscribed, setIsUnsubscribed] = useState(false);
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="50vh"
    >
      <State loading={loading}>
        <Box
          sx={{
            bgcolor: "grey.300",
            p: 2,
            borderRadius: 1,
            width: "30%",
            minWidth: "fit-content",
          }}
        >
          {isUnsubscribed ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Typography variant="h5">It&apos;s official</Typography>
              <Typography variant="body1">
                You have unsubscribed. Thanks!
              </Typography>
            </Box>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Typography variant="h5">Unsubscribe</Typography>
              <Typography variant="body1">
                Unsubscribe{" "}
                <Typography component="span" fontWeight="bold">
                  {primaryEmail}
                </Typography>{" "}
                from {unsubscribeDomain}.
              </Typography>
              <Unsubscribe
                emsUserToken={emsUserToken}
                onCompleted={() => setIsUnsubscribed(true)}
              >
                <Button
                  sx={{ alignSelf: "flex-start" }}
                  category={ButtonCategory.Secondary}
                >
                  Unsubscribe
                </Button>
              </Unsubscribe>
            </Box>
          )}
        </Box>
      </State>
    </Box>
  );
};
